module.exports = __webpack_public_path__ + "static/logo-pinterest-a37bc5bc8d57fb7db689c04aea0baaa2.png";